const de = {
    "dbm.stage.nav.home": "Home",
    "dbm.stage.nav.settlement": "Abrechnung",
    "dbm.stage.nav.spot": "Spot",
    "dbm.stage.nav.forward": "Forward",
    "dbm.stage.search": "Suche",
    "dbm.stage.search.add.to.spot": "Spot+",
    "dbm.stage.search.no.result": "Ihre Suche ergab keine Treffer.",
    "dbm.button.menu": "Menü",
    "dbm.button.options": "Optionen",
    "dbm.button.options.toggle": "Optionen umschalten",
    "dbm.button.close": "Schließen",
    "dbm.button.valueDateCalendar": "Valutenkalender",
    "dbm.button.valueDateCalendar.toggle": "Valutenkalender",
    "dbm.export.pdf": "PDF",
    "dbm.export.csv": "CSV",
    "dbm.export.xlsx": "Excel",
    "dbm.export.exportAsLabel": "{tableName}\nspeichern als",
    "dbm.export.yearlyAverageRates": "Jahres&shy;durch&shy;schnitts&shy;kurse",
    "dbm.export.monthlyOverview": "Monats&shy;über&shy;sicht",
    "dbm.export.selectYear": "Jahr für den Export auswählen",
    "dbm.export.selectMonth": "Monat für den Export auswählen",
     "dbm.export.monthlyUltimo": "Monatsdurchschnittskurse",
    "dbm.export.EndofMonthRates": "Monatsultimokurse",
    "dbm.table.lastUpdate": "Aktualisiert am: ",
    "dbm.table.export.lastUpdate": "Dokument erstellt am: ",
    "dbm.table.export.yearlyAvgTitle": "Jahresdurchschnittskurse Devisen - {year}",
    "dbm.table.export.monthlyOverview": "Monatsübersicht Devisen - {month} {year}",
     "dbm.table.export.monthlyUltimo": "Monatsdurchschnittskurse - {month} {year}",
    "dbm.table.export.EndofMonthRates": "Monatsultimokurse - {month} {year}",
    "dbm.table.loadingData": "Lade Daten, bitte warten Sie einen Moment…",
    "dbm.table.emptyData": "Aktuell sind für diesen Zeitraum keine Daten verfügbar",
    "dbm.currency.base": "Basiswährung",
    "dbm.currency.counter": "Gegenwährung",
    "dbm.currency.holiday": "Feiertag",
    "dbm.currency.ccyPair": "Währungspaar",
    "dbm.currency.valueDate": "Valuta",
    "dbm.currency.bid": "Geld",
    "dbm.currency.ask": "Brief",
    "dbm.currency.previousBid": "Geld Vortag",
    "dbm.currency.previousAsk": "Brief Vortag",
    "dbm.currency.changeAbsolute": "Änderung Abs.",
    "dbm.currency.gainStatus": " Gewinn ",
    "dbm.currency.lossStatus": " Verlust ",
    "dbm.currency.changePercent": "Änderung %",
    "dbm.currency.daysCount": "Tage",
    "dbm.currency.clientBid": "DB Abrechnungskurs Geld",
    "dbm.currency.clientAsk": "DB Abrechnungskurs Brief",
    "dbm.currency.traderBid": "Referenzwechselkurs Geld",
    "dbm.currency.traderAsk": "Referenzwechselkurs Brief",
    "dbm.currency.bidDifference": "Auf-/Abschlag auf Referenzwechselkurs",
    "dbm.valueDate": "Valuta",
    "dbm.dashboard.newsletter.text1": 'Der neue Newsletter "MÄRKTE am Morgen" liefert einen Überblick zu Trends bei Zinsen und Währungen. Ab sofort können sich Interessenten für den Newsletter',
    "dbm.dashboard.newsletter.cta": "anmelden",
    "dbm.dashboard.newsletter.text2": ".",
    "dbm.fixings.type.first": "13 Uhr",
    "dbm.fixings.type.second": "18 Uhr",
    "dbm.settlements.tableFooter": "DB Abrechnungskurse je 1 EUR in Devisen vom {date}, {time} Uhr",
    "dbm.settlements.footnoteLeft": `'<h3>'Hinweis'</h3>' Die angegebenen Preise gelten für Verbraucher sowie ausgewählte Transaktionsarten für Nicht-Verbraucher. Weitere Details finden Sie im Preis- und Leistungsverzeichnis '<a href="https://www.deutsche-bank.de/pk/service-und-kontakt/services/konditionen-und-preise.html" target="_blank" rel="noopener noreferrer">'Konditionen und Preise | Deutsche Bank'</a>'
'<br/><br/>'Der Abrechnungskurs der Deutsche Bank basiert auf dem Referenzwechselkurs zum Abrechnungstermin und enthält einen bankseitigen Auf- oder Abschlag.
'<br/>'`,
    "dbm.settlements.footnoteRight": `
        '<h3>'*Der Renminbi'</h3>' Renminbi, die in der Volksrepublik China ("China Mainland") unterhalten, gehandelt und gezahlt werden,
        sind "Onshore Renminbi" (ISO-Code CNY): Außerhalb von China Mainland handelt es sich um "Offshore Renminbi - Handelsplatz
        Honkong" (CNH).'<br/><br/>'
        "CNH" ist jedoch kein bei der International Organization for Standardization (ISO) registrierter Code und wird
        deshalb weder im Zahlungsverkehr noch für die Kontoinformationen verwandt.`,
    "dbm.options.chooseCcyPairAndPeriod": "Bitte wählen Sie Währung und Zeitraum",
    "dbm.settlement.options.label" : "Optionen Abrechnung",
    "dbm.settlements.options.saveOptionsButton": "OK",
    "dbm.settlements.options.resetOptionsButton": "Optionen Abrechnung zurücksetzen",
    "dbm.settlements.options.fixingsAt": "Fixings vom:",
    "dbm.settlements.options.fixingsAtFootnote": "Alle Kurse werden erst mit einer Verzögerung von max. 2 Stunden angezeigt.",

    "dbm.home.options.label": "Optionen Home",
    "dbm.home.options.changeCurrencyPairs": "Währungspaare anpassen",
    "dbm.home.options.saveOptionsButton": "OK",
    "dbm.home.options.resetOptionsButton": "Optionen Home zurücksetzen",

    "dbm.spot.options.label": "Optionen Spot",
    "dbm.spot.options.addNewCurrencyPair": "Einzelne Währungspaare hinzufügen",
    "dbm.spot.options.addNewCurrencyPairButton": "Währungspaar hinzufügen",
    "dbm.spot.options.addNewGroups": "Gruppen zur Ansicht hinzufügen",
    "dbm.spot.options.saveOptionsButton": "OK",
    "dbm.spot.options.resetOptionsButton": "Optionen Spots zurücksetzen",
    "dbm.spot.options.groups.majors": "Majors",
    "dbm.spot.options.groups.europe": "Europa",
    "dbm.spot.options.groups.emea": "EMEA",
    "dbm.spot.options.groups.g7": "G7",
    "dbm.spot.options.groups.apac": "APAC",
    "dbm.spot.options.groups.nordic": "Nordic",
    "dbm.spot.options.groups.mena": "MENA",
    "dbm.spot.options.groups.americas": "Amerika",
    "dbm.forward.options.label": "Optionen Forward",
    "dbm.forward.options.chooseCurrencyPairs": "Währungspaare wählen",
    "dbm.forward.options.choosePeriod": "Zeiträume wählen",
    "dbm.forward.options.saveOptionsButton": "OK",
    "dbm.forward.options.resetOptionsButton": "Optionen Forward zurücksetzen",
    "dbm.forward.options.addNewCurrencyPairButton": "Währungspaar hinzufügen",
    "dbm.forward.options.appearanceAskBid": "Darstellung Geld / Brief",
    "dbm.forward.options.brokenDate": "Valuta hinzufügen",
    "dbm.forward.options.appearanceSwapPoints": "Swappunkte",
    "dbm.forward.options.appearanceFixings": "Terminkurse",
    "dbm.currencyPair.granularities.1d": "1T",
    "dbm.currencyPair.granularities.1m": "1M",
    "dbm.currencyPair.granularities.3m": "3M",
    "dbm.currencyPair.granularities.6m": "6M",
    "dbm.currencyPair.granularities.ytd": "YTD",
    "dbm.currencyPair.granularities.1y": "1J",
    "dbm.currencyPair.granularities.5y": "5J",
    "dbm.currencyPair.granularities.10y": "10J",
    "dbm.currencyPair.granularities.max": "MAX",
    "dmb.links.contact" : "Kontakt",
    "dmb.links.api" : "API",
    "dmb.links.taxDisclaimer" : "Steuertexte",
    "dmb.links.taxDisclaimer.href" : "https://www.deutsche-bank.de/pk/lp/rechtliche-hinweise.html#parsys-accordion-accordionParsys-accordionentry_8612206",
    "dmb.links.imprint" : "Impressum",
    "dmb.links.imprint.href" : "https://www.db.com/company/de/impressum.htm?kid=imprint.inter-de.redirect",
    "dmb.links.termsOfUse" : "Nutzungsbedingungen",
    "dmb.links.privacyStatement" : "Datenschutz",
    "dmb.links.deutscheBank" : "Deutsche Bank Konzern",
    "dmb.links.deutscheBank.href" : "https://www.db.com/company/index_de.htm"
};

export default de;